import { createFileRoute } from '@tanstack/react-router';
import { DocumentPage, validateNewDocSearch } from '@/components/sales/document-page';

export const Route = createFileRoute('/sales/sales-receipts/new')({
  component: New,
  validateSearch: validateNewDocSearch,
});

function New() {
  const s = Route.useSearch();
  return <DocumentPage kind="sales_receipt" {...s} />;
}
